<template>
  <TabBar activeTabName="misc" />
  <div class="row justify-content-center px-0 mx-0">
    <ManufacturerMainList />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import ManufacturerMainList from '@/components/fleet/ManufacturerMainList.vue'
import NavigationService from '@/services/NavigationService'
import TabBar from '@/components/fleet/TabBar.vue'

@Options({
  components: {
    ManufacturerMainList,
    TabBar
  }
})
export default class ManufacturersList extends Vue {
  mounted () {
    NavigationService.setNavLevel2('Fleet', 'Manufacturers', '#/fleet', '')
  }
}
</script>
